/* eslint-disable @typescript-eslint/no-explicit-any */
import { ConditionRenderer } from "@/components/shared/condition-renderer";
import { typeCheck } from "@/lib/type-check";
import { cn } from "@/lib/utils";
import { DocumentListing } from "./document-listing";
import { DocumentTable } from "./document-table";
import { Fragment } from "react/jsx-runtime";
import { DocumentCollapsible } from "./document-collapsible";
import { isKeyExist } from "@/lib/object-mutation";
import { DocumentListingV2 } from "./document-listing-v2";
import { ErrorBoundary } from "react-error-boundary";
import { DocumentListingError } from "./document-listing-error";
import { DocumentTableV2 } from "./document-table-v2";
import { DocumentListingV3 } from "./document-listing-v3";
type DocumentDetailsViewType = {
  className?: string;
  detailsData?: any;
  updateJsonData?: any;
  originalDetailsData?: any;
};
export const DocumentDetailsView = ({
  className,
  detailsData,
  updateJsonData,
  originalDetailsData,
}: DocumentDetailsViewType) => {
  const documentData = detailsData?.domain_json;

  const isTypeTwo = isKeyExist(documentData, "regions");

  function isValidObject(value: any) {
    return value !== null && typeof value === "object" && !Array.isArray(value);
  }

  return (
    <div className={cn("p-5 ", className)}>
      <div className="flex gap-5 flex-col">
        <ConditionRenderer condition={isTypeTwo}>
          {isValidObject(documentData)
            ? Object.entries(documentData).map(([key, obj]: any, index) => {
                return (
                  <Fragment key={index}>
                    <div className="border bg-white px-4 py-3 rounded-[11px]">
                      {key}
                    </div>

                    <div className="flex flex-col gap-5">
                      {Object.entries(obj).map(
                        ([ObjKey, value]: any, objIndex) => {
                          const review_required = value?.review_required;

                          return (
                            <DocumentCollapsible
                              label={ObjKey}
                              key={objIndex}
                              className="way-1"
                              review_required={review_required}
                              updateJsonData={updateJsonData}
                              pkey={key}
                              originalDetailsData={originalDetailsData}
                            >
                              <ConditionRenderer
                                condition={value?.items ? false : true}
                              >
                                <ErrorBoundary
                                  fallbackRender={({
                                    error,
                                    resetErrorBoundary,
                                  }) => (
                                    <DocumentListingError
                                      error={error}
                                      errorInfo={error.stack || ""}
                                      resetErrorBoundary={resetErrorBoundary}
                                    />
                                  )}
                                >
                                  {Array.isArray(value) ? (
                                    <DocumentListingV3
                                      data={value}
                                      keyValue={key}
                                      parentKey={`detailsData.domain_json.${key}.${ObjKey}`}
                                    />
                                  ) : (
                                    <DocumentListingV2
                                      data={value}
                                      keyValue={key}
                                      parentKey={`detailsData.domain_json.${key}.${ObjKey}`}
                                      originalDetailsData={originalDetailsData}
                                    />
                                  )}
                                </ErrorBoundary>
                              </ConditionRenderer>
                              <ConditionRenderer
                                condition={value?.items ? true : false}
                              >
                                <ErrorBoundary
                                  fallbackRender={({
                                    error,
                                    resetErrorBoundary,
                                  }) => (
                                    <DocumentListingError
                                      error={error}
                                      errorInfo={error.stack || ""}
                                      resetErrorBoundary={resetErrorBoundary}
                                    />
                                  )}
                                >
                                  <DocumentTableV2
                                    data={value.items}
                                    keyValue={key}
                                    parentKey={`detailsData.domain_json.${key}.${ObjKey}.items`}
                                  />
                                </ErrorBoundary>
                              </ConditionRenderer>
                            </DocumentCollapsible>
                          );
                        },
                      )}
                    </div>
                  </Fragment>
                );
              })
            : null}
        </ConditionRenderer>
        <ConditionRenderer condition={!isTypeTwo}>
          {isValidObject(documentData)
            ? Object.entries(documentData).map(([key, obj]: any, index) => {
                return (
                  <DocumentCollapsible
                    label={key}
                    key={index}
                    isParent={true}
                    className="way-2"
                  >
                    <div className="flex flex-col  gap-5 pl-6 ">
                      {Object.entries(obj).map(([ObjKey, value], objIndex) => {
                        return (
                          <DocumentCollapsible
                            label={ObjKey}
                            key={objIndex}
                            className="way-3"
                          >
                            <ConditionRenderer
                              condition={typeCheck(value) === "Object"}
                            >
                              <ErrorBoundary
                                fallbackRender={({
                                  error,
                                  resetErrorBoundary,
                                }) => (
                                  <DocumentListingError
                                    error={error}
                                    errorInfo={error.stack || ""}
                                    resetErrorBoundary={resetErrorBoundary}
                                  />
                                )}
                              >
                                <DocumentListing
                                  data={value}
                                  keyValue={key}
                                  parentKey={`detailsData.domain_json.${key}.${ObjKey}`}
                                />
                              </ErrorBoundary>
                            </ConditionRenderer>
                            <ConditionRenderer
                              condition={typeCheck(value) === "Array"}
                            >
                              <ErrorBoundary
                                fallbackRender={({
                                  error,
                                  resetErrorBoundary,
                                }) => (
                                  <DocumentListingError
                                    error={error}
                                    errorInfo={error.stack || ""}
                                    resetErrorBoundary={resetErrorBoundary}
                                  />
                                )}
                              >
                                <DocumentTable
                                  data={value}
                                  keyValue={key}
                                  parentKey={`detailsData.domain_json.${key}.${ObjKey}`}
                                />
                              </ErrorBoundary>
                            </ConditionRenderer>
                          </DocumentCollapsible>
                        );
                      })}
                    </div>
                  </DocumentCollapsible>
                );
              })
            : null}
        </ConditionRenderer>
      </div>
    </div>
  );
};
